import { FailedReport, ReportMetadata } from '../../interfaces';

export type RetriedReport = FailedReport;
export type RetriedReportMetaData = ReportMetadata;

export enum RETRY_REPORT_BUSINESS_ERRORS {
  REPORT_NOT_FOUND = 'REPORT_NOT_FOUND',
  REPORTS_LIMIT_REACHED = 'REPORTS_LIMIT_REACHED'
}

export type HandleRetryReportRequest = (id: string) => Promise<Response>;
export type HandleOpenRetryDialog = (item: RetriedReport) => void;
